import * as React from "react";
import { Card } from "azure-devops-ui/Card";
import { IHeaderCommandBarItem } from "azure-devops-ui/HeaderCommandBar";
import { ColumnFill, ColumnMore, renderSimpleCell, Table } from "azure-devops-ui/Table";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { ListSelection, ISimpleListCell } from "azure-devops-ui/List";
import { ArrayItemProvider } from "azure-devops-ui/Utilities/Provider";

const commandBarItems: IHeaderCommandBarItem[] = [
    {
        id: "testDownload",
        text: "Download",
        onActivate: () => {
            alert("Example text");
        },
        iconProps: {
            iconName: "Download"
        }
    },
    {
        id: "testDelete",
        text: "Delete",
        onActivate: () => {
            alert("Example text");
        },
        iconProps: {
            iconName: "Delete"
        }
    },
    {
        id: "testCreate",
        text: "Add",
        onActivate: () => {
            alert("This would normally trigger a modal popup");
        },
        iconProps: {
            iconName: "Add"
        },
        isPrimary: true,
        tooltipProps: {
            text: "This is the tooltip"
        }
    },
    {
        id: "testShare",
        text: "Share",
        onActivate: () => {
            alert("Example text");
        },
        iconProps: {
            iconName: "Share"
        }
    }
];

interface ITableItem {
    name: ISimpleListCell;
    calories?: number;
    cost?: string;
}

function onSizeSizable(event: MouseEvent, index: number, width: number) {
    (sizableColumns[index].width as ObservableValue<number>).value = width;
}

const sizableColumns = [
    {
        id: "name",
        name: "Name",
        minWidth: 50,
        width: new ObservableValue(300),
        renderCell: renderSimpleCell,
        onSize: onSizeSizable
    },
    {
        id: "calories",
        name: "Calories",
        maxWidth: 300,
        width: new ObservableValue(200),
        renderCell: renderSimpleCell,
        onSize: onSizeSizable
    },
    { id: "cost", name: "Cost", width: new ObservableValue(200), renderCell: renderSimpleCell },
    ColumnFill
];

function onSizeMore(event: MouseEvent, index: number, width: number) {
    (moreColumns[index].width as ObservableValue<number>).value = width;
}

const moreColumns = [
    {
        id: "name",
        minWidth: 50,
        name: "Name",
        onSize: onSizeMore,
        readonly: true,
        renderCell: renderSimpleCell,
        width: new ObservableValue(200)
    },
    {
        id: "calories",
        maxWidth: 300,
        name: "Calories",
        onSize: onSizeMore,
        readonly: true,
        renderCell: renderSimpleCell,
        width: new ObservableValue(100)
    },
    {
        id: "cost",
        name: "Cost",
        onSize: onSizeMore,
        readonly: true,
        renderCell: renderSimpleCell,
        width: new ObservableValue(100)
    },
    ColumnFill,
    new ColumnMore(() => {
        return {
            id: "sub-menu",
            items: [
                { id: "submenu-one", text: "SubMenuItem 1" },
                { id: "submenu-two", text: "SubMenuItem 2" }
            ]
        };
    })
];

const tableItems = new ArrayItemProvider<ITableItem>([
    {
        name: { iconProps: { iconName: "Home" }, text: "Potato Chips" },
        calories: 400,
        cost: "$2.99"
    },
    {
        name: { iconProps: { iconName: "Home" }, text: "Yogurt" },
        calories: 140,
        cost: "$3.99"
    },
    {
        name: { iconProps: { iconName: "Home" }, text: "Milk" },
        cost: "$2.50"
    }
]);

export default class TableCardExample extends React.Component {
    private selection = new ListSelection(true);
    public render(): JSX.Element {
        return (
            <Card
                className="flex-grow bolt-table-card"
                titleProps={{ text: "Food Inventory", ariaLevel: 3 }}
                headerCommandBarItems={commandBarItems}
            >
                <Table<Partial<ITableItem>>
                    ariaLabel="Food Inventory Table"
                    columns={sizableColumns}
                    itemProvider={tableItems}
                    selection={this.selection}
                    onSelect={(event, data) => console.log("Select Row - " + data.index)}
                />
            </Card>
        );
    }
}
